const UserSearchFilterFormConfig = require('./formConfig');

const internals = {};

internals.ROLE_INDEPENDENT_VALUE_NAMES = new Set([
    'allByMatches',
    'classId',
    'contextFilter',
    'contextFilterType',
    'debugMatching',
    'includeStaff',
    'sortType',
    'useMatchScoring',
    'viewAll'
]);

internals.COMMON_VALUE_NAMES = new Set([
    'contextFilter',
    'interests',
    'name'
]);

module.exports.DEFAULT_FIELD_NAMES = UserSearchFilterFormConfig.DEFAULT_FIELD_NAMES;
module.exports.ADMIN_FIELD_NAMES = UserSearchFilterFormConfig.ADMIN_FIELD_NAMES;

module.exports.pruneForSelectedUserType = (criteria = {}, options = {}) => {

    if (!criteria || typeof criteria !== 'object') {
        return {};
    }

    const selectedRoleGroup = criteria.contextFilter || options.selectedRoleGroup || '';
    const selectedLocationType = criteria.locationType || options.selectedLocationType || '';
    const applicableValueNames = internals.getApplicableValueNames({
        ...options,
        selectedLocationType,
        selectedRoleGroup
    });

    return Object.keys(criteria).reduce((collector, key) => {

        if (internals.ROLE_INDEPENDENT_VALUE_NAMES.has(key) || applicableValueNames.has(key)) {
            collector[key] = criteria[key];
        }

        return collector;
    }, {});
};

internals.asArray = (value) => Array.isArray(value) ? value : [];

internals.getRoleOptions = ({ availableRoleGroups, schoolRoles, roleOptions }) => {

    const safeRoleOptions = internals.asArray(roleOptions);
    if (safeRoleOptions.length) {
        return safeRoleOptions;
    }

    const safeAvailableRoleGroups = internals.asArray(availableRoleGroups);
    if (safeAvailableRoleGroups.length) {
        return safeAvailableRoleGroups;
    }

    return internals.asArray(schoolRoles);
};

internals.buildRoleContext = ({
    allRoles,
    availableRoleGroups,
    badges,
    departments,
    roleOptions,
    schoolRoles,
    selectedRoleGroup
} = {}) => {

    const safeRoleOptions = internals.getRoleOptions({
        availableRoleGroups,
        roleOptions,
        schoolRoles
    });
    const safeAllRoles = internals.asArray(allRoles).filter(Boolean);
    const safeBadges = internals.asArray(badges);
    const safeDepartments = internals.asArray(departments);
    const usesRoleGroups = internals.asArray(availableRoleGroups).length > 0;
    const selectedOption = safeRoleOptions.find(({ name }) => name === selectedRoleGroup);
    const roles = usesRoleGroups && selectedOption ?
        safeAllRoles.filter(({ roleGroupId }) => roleGroupId === selectedOption.id) :
        [selectedOption].filter(Boolean);
    const roleIds = roles.map(({ id }) => id);
    const canEdit = (permission) => roles.some((role) => role.permissions?.[permission]);

    return {
        isParent: selectedRoleGroup === 'parent',
        canEdit,
        badges: safeBadges.filter((badge) => badge?.used === true && roleIds.includes(badge.roleId)),
        departments: safeDepartments.filter((department) => {

            return department?.used === true && internals.asArray(department.usedBy).some((roleId) => roleIds.includes(roleId));
        })
    };
};

internals.getApplicableValueNames = (options = {}) => {

    const {
        selectedRoleGroup
    } = options;

    if (!selectedRoleGroup) {
        return new Set(internals.COMMON_VALUE_NAMES);
    }

    const roleOptions = internals.getRoleOptions(options);
    const roleContext = internals.buildRoleContext({
        ...options,
        roleOptions
    });
    const fields = UserSearchFilterFormConfig.internals.buildFields({
        ...options,
        fieldNames: options.fieldNames || UserSearchFilterFormConfig.DEFAULT_FIELD_NAMES,
        fieldProps: {},
        forApplicability: true,
        renderInterestsHeader: internals.noop,
        renderLocationHeader: internals.noop,
        roleContext,
        roleOptions,
        setSelectedLocationType: internals.noop,
        setSelectedRoleGroup: internals.noop
    });

    return fields.reduce((collector, field = {}) => {

        [field.name, field.textFieldName, field.errorFieldName, field.key]
            .filter(Boolean)
            .forEach((fieldName) => {

                UserSearchFilterFormConfig.internals.getFieldValueNames(fieldName).forEach((valueName) => {

                    collector.add(valueName);
                });
            });

        return collector;
    }, new Set());
};

internals.noop = () => null;

module.exports.internals = internals;
